import BuildingImage from "../../assets/images/building.svg";
import FilingImage from "../../assets/images/filing.svg";
import { ElemID } from "../editor/constants";
import { hide, unhide } from "../../utils";
import { EventBus, Events } from "../eventBus";

const placeholders = {
  "preparing-pdf": {
    image: BuildingImage,
    imageAltText: "Illustration of three people building a website",
    text: "Preparing your pdf ...",
  },
  "generating-pdf": {
    image: FilingImage,
    imageAltText:
      "Illustration of someone placing a document in a paper folder",
    text: "Generating your pdf ...",
  },
};

const placeholderComponent = document.getElementById(
  ElemID.PLACEHOLDER_COMPONENT,
);
const placeholderImage = document.getElementById("placeholder-image");
const placeholderText = document.getElementById("placeholder-text");

function showPlaceholder(placeholderName) {
  const placeholder = placeholders[placeholderName];
  if (!placeholder) {
    console.error("Unknown placeholder - " + placeholderName);
    return;
  }

  placeholderImage.src = placeholder.image;
  placeholderImage.alt = placeholder.imageAltText;
  placeholderText.textContent = placeholder.text;

  unhide(placeholderComponent);
}

EventBus.subscribe(Events.HIDE_PLACEHOLDER, function () {
  hide(placeholderComponent);
});

EventBus.subscribe(Events.SHOW_PLACEHOLDER_PREPARING_PDF, function () {
  showPlaceholder("preparing-pdf");
});

EventBus.subscribe(Events.SHOW_PLACEHOLDER_GENERATING_PDF, function () {
  showPlaceholder("generating-pdf");
});
